import React from "react";
import { MessageBoxWarning as WebMessageBox } from "../WebStyles";
import { MessageBoxWarning as WindowsMessageBox } from "../WindowsStyles";
import { MessageBoxWarning as MacMessageBox } from "../MacStyles";
import { MessageBoxWarning as LinuxMessageBox } from "../LinuxStyles";
import { MessageBoxWarning as IosMessageBox } from "../iOSStyles";
import { MessageBoxWarning as AndroidMessageBox } from "../AndroidStyles";
import { DEVICE_OS } from "@pcloud/web-utilities/dist/config/constants";

const MessageBoxWarning = ({ os, ...rest}) => {
  switch (os) {
    case DEVICE_OS.Android:
      return <AndroidMessageBox {...rest}/>
    case DEVICE_OS.iOS:
      return <IosMessageBox {...rest}/>
    case DEVICE_OS.Web:
      return <WebMessageBox {...rest}/>
    case DEVICE_OS.Win:
      return <WindowsMessageBox {...rest}/>
    case DEVICE_OS.MacOSX:
      return <MacMessageBox {...rest}/>
    case DEVICE_OS.Linux:
      return <LinuxMessageBox {...rest}/>
    default:
      return <WebMessageBox {...rest}/>
  }
};

export default MessageBoxWarning;
